import React from 'react';
import { Search } from 'lucide-react';

interface FilterBarProps {
    searchPlaceholder?: string;
    searchTerm: string;
    onSearchChange: (value: string) => void;
    children?: React.ReactNode;
}

export function FilterBar({
    searchPlaceholder = "Buscar...",
    searchTerm,
    onSearchChange,
    children
}: FilterBarProps) {
    return (
        <div className="flex flex-col sm:flex-row gap-4 w-full md:w-auto items-center">
            <div className="relative flex-1 w-full sm:w-64">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 w-5 h-5" />
                <input
                    type="text"
                    placeholder={searchPlaceholder}
                    value={searchTerm}
                    onChange={(e) => onSearchChange(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 border border-slate-200 rounded-lg text-sm bg-slate-50 focus:bg-white focus:ring-2 focus:ring-primary-500 outline-none transition-all shadow-sm"
                />
            </div>
            {children && (
                <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
                    {children}
                </div>
            )}
        </div>
    );
}
